export default {
    authApi: process.env.vueAppAuthApi,
    api: process.env.vueAppApi,
    baseUrl: window.location.protocol + '//' + window.location.host,
    viaCepApi: process.env.vueAppViaCepApi,
    blobStorageAzureApi: process.env.vueAppBlobStorage,
    medicalEscales: process.env.vueAppMedicalScales,
    navProUrl: process.env.vueAppNavProUrl,
}
